import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { keepCmsHistoryDialogData } from './keep-cms-history-dialog.data';
@Component({
    selector : 'keep-cms-history-dialog',
    template: require('./keep-cms-history-dialog.component.html'),
    styles: [require('./keep-cms-history-dialog.component.scss')]
})


export class KeepCmsHistoryDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: keepCmsHistoryDialogData) {}
    public keepDataFunc(keep:boolean){
        //console.log(keep)
        this.data.keepData = keep;
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/keep-cms-history-dialog/keep-cms-history-dialog.component.ts